import { KlaviyoPopupAdapter } from '@/components/popup-logic/adapters/klaviyo';
import { Popup } from '@/components/popup-logic/popup';

type KlaviyoIDs = {
  displayName: string;
  desktop: string;
  mobile: string;
};

export default function addDefinitions(): boolean {
  try {

    const vendor = window?.PDP?.productData?.vendor?.toLowerCase?.() ?? '';
    let isMedispaPage = false;
    if (
      document.body.classList.contains('template-medispa-v2') ||
      document.body.classList.contains('medispa-lp') ||
      vendor.includes('medispa')
    ) {
      isMedispaPage = true;
    }

    // Only add on Medispa pages
    if (!isMedispaPage) {
      return false;
    }

    // Don't run on pages where window.theme.medispaCalendarConfig.products contains a product with pay_in_store = true
    const hasPayInStoreProduct = window.theme.medispaCalendarConfig.products.some(
      (product) => product?.pay_in_store === true,
    );

    if (hasPayInStoreProduct) {
      return false;
    }

    // Map of popup IDs to their desktop and mobile variants
    // Key is the market code (e.g. "zh-hans", "en"). "default" is used as a fallback
    const klaviyoFormMap = new Map<string, KlaviyoIDs>([
      [
        'default',
        {
          displayName: 'Multi-step email & SMS & Countdown [Medispa]',
          desktop: 'QTuEQs',
          mobile: 'RgpGdn',
        },
      ],
    ]);

    const currentMarket = window.Shopify.routes.root.replace(/\//g, '');

    const klaviyoID = klaviyoFormMap.get(currentMarket) || klaviyoFormMap.get('default')!;

    const deviceType = matchMedia('(pointer: fine)').matches ? 'desktop' : 'mobile';

    const adapter = new KlaviyoPopupAdapter({ id: klaviyoID[deviceType] });
    const popup = new Popup(adapter, {
      id: klaviyoID[deviceType],
      displayName: klaviyoID.displayName,
    });

    // window.popupMonitor.addPopup(popup);

    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}
